<template>
  <portal :to="portal">
    <transition name="bbFade" appear>
      <div :class="cssClass">
        <span v-if="!isError" class="alert__icon alert__icon--success">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.7104 7.20986C18.6175 7.11613 18.5069 7.04174 18.385 6.99097C18.2632 6.9402 18.1324 6.91406 18.0004 6.91406C17.8684 6.91406 17.7377 6.9402 17.6159 6.99097C17.494 7.04174 17.3834 7.11613 17.2904 7.20986L9.84044 14.6699L6.71044 11.5299C6.61392 11.4366 6.49998 11.3633 6.37512 11.3141C6.25026 11.2649 6.11694 11.2408 5.98276 11.2431C5.84858 11.2454 5.71617 11.2741 5.59309 11.3276C5.47001 11.3811 5.35868 11.4583 5.26544 11.5549C5.1722 11.6514 5.09889 11.7653 5.04968 11.8902C5.00048 12.015 4.97635 12.1484 4.97867 12.2825C4.98099 12.4167 5.00972 12.5491 5.06321 12.6722C5.1167 12.7953 5.19392 12.9066 5.29044 12.9999L9.13044 16.8399C9.2234 16.9336 9.334 17.008 9.45586 17.0588C9.57772 17.1095 9.70843 17.1357 9.84044 17.1357C9.97245 17.1357 10.1032 17.1095 10.225 17.0588C10.3469 17.008 10.4575 16.9336 10.5504 16.8399L18.7104 8.67986C18.8119 8.58622 18.893 8.47257 18.9484 8.34607C19.0038 8.21957 19.0324 8.08296 19.0324 7.94486C19.0324 7.80676 19.0038 7.67015 18.9484 7.54365C18.893 7.41715 18.8119 7.3035 18.7104 7.20986Z"
              fill="#155724"
            />
          </svg>
        </span>
        <span v-else class="alert__icon alert__icon--error">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.36 15.33C8.15844 15.4993 8.03176 15.7412 8.00742 16.0033C7.98308 16.2654 8.06306 16.5265 8.23 16.73C8.31395 16.8313 8.41705 16.915 8.5334 16.9763C8.64975 17.0377 8.77706 17.0755 8.90803 17.0875C9.03901 17.0996 9.17108 17.0857 9.29669 17.0467C9.42229 17.0076 9.53896 16.9442 9.64 16.86C10.3085 16.321 11.1413 16.0271 12 16.0271C12.8587 16.0271 13.6915 16.321 14.36 16.86C14.5399 17.0091 14.7664 17.0905 15 17.09C15.2036 17.088 15.4017 17.0239 15.5679 16.9063C15.734 16.7887 15.8604 16.6231 15.9299 16.4318C15.9995 16.2405 16.009 16.0325 15.9572 15.8356C15.9054 15.6387 15.7947 15.4623 15.64 15.33C14.6081 14.5006 13.3239 14.0484 12 14.0484C10.6761 14.0484 9.39188 14.5006 8.36 15.33ZM9.21 10.54C9.39737 10.7263 9.65082 10.8308 9.915 10.8308C10.1792 10.8308 10.4326 10.7263 10.62 10.54C10.8063 10.3526 10.9108 10.0992 10.9108 9.835C10.9108 9.57081 10.8063 9.31736 10.62 9.13C10.0477 8.58699 9.2889 8.28428 8.5 8.28428C7.71111 8.28428 6.95228 8.58699 6.38 9.13C6.27532 9.21965 6.1903 9.32997 6.13028 9.45403C6.07026 9.57809 6.03653 9.71323 6.03121 9.85095C6.02589 9.98867 6.04909 10.126 6.09937 10.2543C6.14964 10.3826 6.2259 10.4992 6.32335 10.5967C6.42081 10.6941 6.53736 10.7704 6.66568 10.8206C6.79401 10.8709 6.93134 10.8941 7.06906 10.8888C7.20678 10.8835 7.34191 10.8497 7.46597 10.7897C7.59004 10.7297 7.70036 10.6447 7.79 10.54C7.88297 10.4463 7.99357 10.3719 8.11543 10.3211C8.23729 10.2703 8.36799 10.2442 8.5 10.2442C8.63202 10.2442 8.76272 10.2703 8.88458 10.3211C9.00644 10.3719 9.11704 10.4463 9.21 10.54ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM17.62 9.13C17.0477 8.58699 16.2889 8.28428 15.5 8.28428C14.7111 8.28428 13.9523 8.58699 13.38 9.13C13.2162 9.3213 13.1306 9.56738 13.1403 9.81905C13.15 10.0707 13.2543 10.3095 13.4324 10.4876C13.6105 10.6657 13.8493 10.77 14.101 10.7797C14.3526 10.7894 14.5987 10.7038 14.79 10.54C14.883 10.4463 14.9936 10.3719 15.1154 10.3211C15.2373 10.2703 15.368 10.2442 15.5 10.2442C15.632 10.2442 15.7627 10.2703 15.8846 10.3211C16.0064 10.3719 16.117 10.4463 16.21 10.54C16.3974 10.7263 16.6508 10.8308 16.915 10.8308C17.1792 10.8308 17.4326 10.7263 17.62 10.54C17.8063 10.3526 17.9108 10.0992 17.9108 9.835C17.9108 9.57081 17.8063 9.31736 17.62 9.13Z"
              fill="#721C24"
            />
          </svg>
        </span>

        <slot></slot>
        <span class="alert__close" @click="$emit('close')">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.6979 6L12 10.3021L10.3021 12L6 7.6979L1.6979 12L0 10.3021L4.3021 6L0 1.6979L1.6979 0L6 4.3021L10.3021 0L12 1.6979L7.6979 6Z"
              fill="#004085"
            />
          </svg>
        </span>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: "AlertIntern",
  props: {
    portal: {
      type: String,
      default: "alerts",
    },
    type: {
      type: String,
      default: "success",
    },
  },
  computed: {
    isError() {
      return this.type === "error";
    },
    cssClass() {
      if (this.isError) return "alert alert--error";
      return "alert alert--success";
    },
  },
};
</script>
